import { render } from "./functional_information_wealths.vue?vue&type=template&id=99c7c29e&scoped=true"
import script from "./functional_information_wealths.vue?vue&type=script&lang=js"
export * from "./functional_information_wealths.vue?vue&type=script&lang=js"

import "./functional_information_wealths.vue?vue&type=style&index=0&id=99c7c29e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c7c29e"]])

export default __exports__